
import { Vue, Component, Prop, Watch  } from 'vue-property-decorator';
import AppFooter from '@/components/AppFooter.vue';
import AppNavbar from '@/components/AppNavbar.vue';
import Loading from '@/components/Loading.vue';

import router, { nonUserRelatedPath } from '@/router';
import userx from '@/store/modules/userx';
import { LoginStatus } from '@/store/models.def';
import { navigationValidation } from '@/router';
import ProgressToaster from './components/toaster/ProgressToaster.vue';
@Component({
  components: {
	AppFooter,
	AppNavbar,
	Loading,
	ProgressToaster,
  },
})
export default class App extends Vue {

	get loginStatus() {
		return userx.loginStatus;
	}
	get needCompleteRegistration() {
		return userx.needCompleteRegistration;
	}
	get userReady() {
		if (userx.loginStatus === 'loading') { return false; }
		if (userx.loginStatus === 'logged out' ) { return true; }
		if (userx.needCompleteRegistration === undefined ) { return false; }
		return true;
	}
	get emailVerified() {
		return (userx.user && userx.user.emailVerified);
	}
	get emailVerificationSent() {
		return (userx.emailVerificationSent);
	}
	get nonUserRelated() {
		return nonUserRelatedPath.includes(this.$route.path);
	}
	@Watch('loginStatus')
  	public onLoginStatusChanged(val: LoginStatus, oldVal: LoginStatus) {
		this.navigationValidation();
	}
	@Watch('needCompleteRegistration')
  	public onNeedCompleteRegistrationChanged(val: boolean | undefined, oldVal: boolean | undefined) {
		this.navigationValidation();
	}

	public navigationValidation() {
		const validation = navigationValidation(this.$route);
		if (!validation.success && validation.newRoute) {
			if (validation.newRoute.replace) {
				router.replace(validation.newRoute);
			} else {
				router.push(validation.newRoute);
			}
		}
	}

	public sendEmailVerification(e: any) {
		userx.sendEmailVerification();
	}

	public created() {
		console.log('App', this, this.$root);

	}
}
